import React from 'react';
import './MinorTag.css';

interface MinorTagProps {
  applicantType?: string | null;
  variant?: 'row' | 'stacked';
  /** Also label an adult's case ("Adult"), for the Applicant column and the case page. */
  showAdult?: boolean;
}

/**
 * Marks a case filed for a child. Renders nothing for an adult case, which is
 * almost every case, so its appearing at all is the signal: two parents sign,
 * and the bundle carries the birth certificate and both parents' documents.
 */
const MinorTag: React.FC<MinorTagProps> = ({ applicantType, variant = 'row', showAdult = false }) => {
  if (applicantType !== 'minor') {
    if (!showAdult) return null;
    return (
      <span className={`case-minor-tag case-minor-tag--adult case-minor-tag--${variant}`} data-testid="case-adult-tag">
        Adult
      </span>
    );
  }
  return (
    <span
      className={`case-minor-tag case-minor-tag--${variant}`}
      data-testid="case-minor-tag"
      title="NIF for a child: both parents (or one, with proof of sole guardianship) sign."
    >
      Minor
    </span>
  );
};

export default MinorTag;
